<template>
  <div class="queue-app" :dir="getLanguage === 'ar' ? 'rtl' : 'ltr'">
<!--    button-->
    <div
      v-if="getWidgetSettings.position"
      :style="`backgroundColor: ${getWidgetSettings.button_color}; box-shadow: 0 3px 20px ${getWidgetSettings.button_color}; ${getWidgetSettings.position}: ${getWidgetSettings.lat}%; bottom: ${getWidgetSettings.lng}%;`"
      :class="`icon icon-fill queue-fixed ${getWidgetSettings.animation}`"
      v-b-toggle.sidebar-2queue-me
    >
      <div v-if="getWidgetSettings.icon === 'one_line' || getWidgetSettings.icon === 'two_lines'">
        <p :class="getWidgetSettings.second_line ? 'two-text-first' : 'one-text'">{{ getWidgetSettings.first_line }}</p>
        <p class="two-text-second">{{ getWidgetSettings.second_line }}</p>
      </div>
      <b-icon v-else variant="white" class="icon-b" :icon="getWidgetSettings.icon" />
    </div>
<!--    sidebar-->
    <b-sidebar
      id="sidebar-2queue-me"
      right
      shadow
    >
      <b-overlay
        :show="isLoading"
        opacity="1"
        spinner-variant="secondary"
        no-wrap
      />
      <template class="queue-title" #title>
        <div
          v-if="haveBranches"
        >
          {{ getWidgetSettings.title }}
        </div>
        <transition v-else name="fade" mode="out-in">
          <div
            v-if="!showBookingForm && !showBookingPage && !isLoading"
          >
            {{ getWidgetSettings.title }}
          </div>
          <b-button
            v-if="showBookingForm || showBookingPage && !isLoading"
            size="sm"
            class="flat-button"
            variant="light"
            :style="`color: ${getWidgetSettings.main_color}`"
            @click="backToBranches"
          >{{ i18n.t('all-branches') }}
          </b-button>
        </transition>
      </template>
      <transition name="fade" mode="out-in">
        <BranchOffices
          v-show="!showBookingForm && !showBookingPage && !isLoading"
          @setBranch="setChoiceBranch"
        />
      </transition>
        <div
          v-show="showBookingPage && !isLoading"
          class="px-3 py-2"
        >
          <b-row align-self="center" class="mb-2 pb-2">
            <b-col align="end" class="pr-0">
              <b-button
                @click="tabsIndex=0"
                :style="{backgroundColor: tabsIndex === 1 ? '#f8f9fa' : getWidgetSettings.main_color, color: tabsIndex === 1 ? getWidgetSettings.main_color : ''}"
                :class="`${tabsIndex === 0 ? '': 'queue-bold-focus'} queue-tab p-0 pt-2 pb-2 ${getWidgetSettings.size ? 'queue-lg-tab': 'queue-sm-tab'}`"
              >
                {{ getWidgetSettings.left_tab }}
              </b-button>
            </b-col>
            <b-col align="start" class="pl-0">
              <b-button
                @click="tabsIndex=1"
                :style="{backgroundColor: tabsIndex === 0 ? '#f8f9fa' : getWidgetSettings.main_color, color: tabsIndex === 0 ? getWidgetSettings.main_color : ''}"
                :class="`${tabsIndex === 1 ? '': 'queue-bold-focus'} queue-tab p-0 pt-2 pb-2 ${getWidgetSettings.size ? 'queue-lg-tab': 'queue-sm-tab'}`"
              >
                {{ getWidgetSettings.right_tab }}
              </b-button>
            </b-col>
          </b-row>
          <div>
  <!--  tab 1 -->
            <div v-show="tabsIndex === 0">
              <!-- if service not exist-->
              <div
                v-if="getServices.length === 0 && !getErrorServiceStatus"
                class="misc-inner p-2 p-sm-3"
              >
                <div class="w-100 text-center">
                  <h5 class="mb-3">
                    {{ i18n.t('not-exist-title') }}️
                  </h5>
                  <p class="mb-2">
                    {{ i18n.t('not-exist-desc') }}
                    <b-link
                      :style="{color: getWidgetSettings.main_color}"
                      to="https://tobook.link/account"
                    >
                      tobook.link
                    </b-link>
                  </p>

                  <!-- image -->
                  <b-img
                    fluid
                    width="300"
                    :src="ImgService"
                    alt="Service not exist"
                  />
                </div>
              </div>
              <!-- if service not exist and services have error -->
              <ShowError v-if="getServices.length === 0 && getErrorServiceStatus" />
              <app-collapse
                accordion
                type="margin"
              >
                <service-collapse
                  v-for="service in getServices"
                  :key="`s-${service.id}`"
                  :service="service"
                  @openForm="showForm"
                />
              </app-collapse>
            </div>
  <!--  tab 2 -->
            <div v-show="tabsIndex === 1">
              <!-- if specialists not exist-->
              <div
                v-if="getWorkspaces.length === 0 && !getErrorWorkspaceStatus"
                class="misc-inner p-2 p-sm-3"
              >
                <div class="w-100 text-center">
                  <h5 class="mb-3">
                    {{ i18n.t('not-exist-title') }}
                  </h5>
                  <p class="mb-2">
                    {{ i18n.t('not-exist-desc') }}
                    <b-link
                      :style="{color: getWidgetSettings.main_color}"
                      to="https://tobook.link/account"
                    >
                      tobook.link
                    </b-link>
                  </p>
                  <!-- image -->
                  <b-img
                    fluid
                    width="300"
                    :src="ImgSpecialist"
                    alt="Specialist not exist"
                  />
                </div>
              </div>
              <!-- if service not exist and services have error -->
              <ShowError v-if="getWorkspaces.length === 0 && getErrorWorkspaceStatus" />
              <app-collapse
                accordion
                type="margin"
              >
                <specialist-collapse
                  v-for="workspace in getWorkspaces"
                  :key="`w-${workspace.id}`"
                  :workspace="workspace"
                  @openForm="showForm"
                />
              </app-collapse>
            </div>
          </div>
        </div>
      <div
        v-if="!showBookingPage && showBookingForm && !isLoading"
        class="px-3 py-2"
      >
        <FormBooking
          :day="selectDay"
          :timeslot="selectTimeslot"
          :locale="getLanguage"
          :service="selectService"
          :workspace="selectWorkspace"
          @close="closeForm"
        />
      </div>
      <div
          v-show="!showBookingPage && !isLoading"
          slot="footer"
          align="center"
        >
          <p class="text-secondary mt-1 mb-1">
            powered by
            <b-link
              href="https://tobook.link"
              target="blank"
              class="text-secondary"
            >
              tobook.link
            </b-link>
          </p>
        </div>
    </b-sidebar>
  </div>
</template>

<script>
import BranchOffices from '@/components/branchOffices/BranchOffices.vue'
import AppCollapse from './components/AppCollapse.vue'
import ServiceCollapse from './components/booking/ServiceCollapse.vue'
import SpecialistCollapse from '@/components/booking/SpecialistCollapse.vue'
import {
 BSidebar, BLink, BImg, BButton, BRow, BCol, BIcon, BOverlay, VBToggle,
} from 'bootstrap-vue'
import FormBooking from '@/components/booking/FormBooking.vue'
import i18n from '@/libs/i18n'
import { mapActions, mapGetters } from 'vuex'
import { localize } from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import ru from 'vee-validate/dist/locale/ru.json'
import ShowError from '@/components/ShowError.vue'
import timeslots from "@/store/modules/timeslots";
localize({
  ru,
  en,
})

export default {
  props: {
    org: {
      type: String,
      required: true,
    },
  },
  components: {
    BSidebar,
    BLink,
    BImg,
    BIcon,
    BButton,
    BRow,
    BCol,
    BOverlay,
    // eslint-disable-next-line vue/no-unused-components
    VBToggle,
    BranchOffices,
    AppCollapse,
    ServiceCollapse,
    FormBooking,
    SpecialistCollapse,
    ShowError,
  },
  async created() {
    await this.fetchWidgetAndServices(this.org).then(() => {
      this.setShowBookingPage()
    })
  },
  data() {
    return {
      tabsIndex: 0,
      servicesThisWorkspace: [],
      record: {},
      selectDay: '',
      selectTimeslot: '',
      selectService: 0,
      selectWorkspace: {},
      showBookingPage: false,
      showBookingForm: false,
      isLoading: false,
      haveBranches: false,
      // eslint-disable-next-line global-require
      ImgService: require('@/assets/images/settings.svg'),
      // eslint-disable-next-line global-require
      ImgSpecialist: require('@/assets/images/re_settings.svg'),
      i18n,
    }
  },
  computed: mapGetters(['getWidgetSettings', 'getServices', 'getWorkspaces', 'getErrorServiceStatus', 'getErrorWorkspaceStatus', 'getLanguage']),
  methods: {
    async backToBranches() {
      await this.fetchWidgetAndServices(this.org)
      this.showBookingPage = false
      this.showBookingForm = false
    },
    setShowBookingPage() {
      this.haveBranches = this.showBookingPage = !(this.getWidgetSettings.parent_org || this.getWidgetSettings.belong_to_parent_org.length)
    },
    setChoiceBranch(val) {
      this.fetchWidgetAndServices(val)
      this.showBookingPage = !this.showBookingPage
    },
    timeslots() {
      return timeslots
    },
    ...mapActions(['fetchSettingsAndServices']),
    currentLocale() {
      i18n.locale = this.getLanguage
      localStorage.setItem('locale', this.getLanguage)
      localize(this.getLanguage)
    },
    closeForm() {
      this.record = {}
      this.showBookingPage = true
      this.showBookingForm = false
    },
    showForm(val) {
      this.selectTimeslot = val.timeslot
      this.selectService = val.service
      this.selectWorkspace = val.workspace
      this.selectDay = val.day
      this.showBookingForm = true
      // if (val.services) {
      //   this.servicesThisWorkspace = val.services
      // }
      this.showBookingPage = false
    },
    fetchWidgetAndServices(val) {
      this.isLoading = true
      return new Promise(resolve => {
        this.fetchSettingsAndServices(val)
          .then(() => {
            if (this.getServices.length === 0) {
              this.tabsIndex = 1
            }
            this.currentLocale()
            setTimeout(() => {
              this.isLoading = false
            }, 500)
            resolve()
          })
          .catch(error => {
            this.isLoading = false
            console.log(error)
          })
      })
    },
  },
}
</script>
<style>
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~vue-select/dist/vue-select.css';
/*@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&display=swap');*/
@import './assets/css/style.css';
@import './assets/css/alert.min.css';
</style>
